export default "__VITE_ASSET__H62d1JjQ__"